import {Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges} from '@angular/core';
import {CubicleSld} from '../../../shared/bsl-reference/cubicle-sld-model';
import {OfferDataManagementHelper} from '../../../shared/util/offer-data-management-helper';
import sldJson from '../../../../../assets/sld.json';
import {Range} from "../../../../shared/model/range-model";

@Component({
  standalone: false,
  selector: 'app-odm-offer-sld',
  templateUrl: './odm-offer-sld.component.html',
  styleUrls: ['./odm-offer-sld.component.less']
})
export class OdmOfferSldComponent implements OnInit, OnChanges {

  @Input() sldList: CubicleSld[];
  @Input() loading: boolean;
  @Output() onClickAddButton = new EventEmitter<CubicleSld[]>();
  @Output() onClickCancelButton = new EventEmitter<string>();

  @Input()
  selectedRange: Range;
  @Input()
  allowedReferenceCategories: String[] = [];

  hasSelectedSld: boolean;
  selectedSld: CubicleSld;
  numberOfFunction: number;
  currentFunction: number;
  isSettingNumberOfFunction = true;
  listOfSelectedSlds: CubicleSld[];
  allSLD: Set<CubicleSld> = new Set<CubicleSld>();
  allSLDCheck = false;
  currentPage = 1;
  pageTotal;
  perPage = 12;
  searchTerm: string = '';
  paginatedFilteredSlds: CubicleSld[];
  filteredSlds: CubicleSld[];


  constructor() {
  }

  ngOnInit() {
    this.initParameters();
  }

  // Populate filteredSld from input parameters and set it as a default value
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sldList || changes.perPage) {
      this.currentPage = 1;
      this.filteredSlds = this.sldList ? Array.from(this.sldList) : [];
      this.setPaginatedResult(this.filteredSlds, 1, this.perPage);
    }
  }

  nextButton() {
    if (this.isSettingNumberOfFunction) {
      this.isSettingNumberOfFunction = false;
    } else {
      this.listOfSelectedSlds.push(this.selectedSld);
      this.hasSelectedSld = false;
      this.currentFunction = this.currentFunction + 1;
    }
  }

  addButton() {
    this.listOfSelectedSlds.push(this.selectedSld);
    this.onClickAddButton.emit(this.listOfSelectedSlds);
    this.initParameters();
  }

  cancelButton() {
    this.initParameters();
    this.onClickCancelButton.emit('skip');
  }

  getSldImagePath(sldFileName: string): string {
    let pathSld: string;
    pathSld = './assets/sld/' + sldFileName;
    return pathSld;
  }

  setSldValue(sld: CubicleSld) {
    this.hasSelectedSld = true;
    this.selectedSld = sld;
  }

  isSelectedImage(sld): boolean {
    return this.hasSelectedSld && sld === this.selectedSld;
  }

  /**
   * Function to check the coherency of the number of function fields
   */
  onChangeFunctionNumber() {
    if (!this.isValidNumber()) {
      this.numberOfFunction = 1;
    }

    if (this.numberOfFunction < 1) {
      this.numberOfFunction = 1;
    } else if (this.numberOfFunction > 10) {
      this.numberOfFunction = 10;
    }
  }

  /**
   * When user set all SLD or not
   */
  onChangeAllSld() {
    this.allSLDCheck = !this.allSLDCheck;
    this.currentPage = 1;
    this.getSldList(1, this.perPage);
  }

  isValidNumber() {
    if (!this.numberOfFunction) {
      return false;
    }
    const regex = new RegExp('^[0-9]*$');
    return regex.test(this.numberOfFunction.toString());
  }

  pageChange(event: any) {
    this.currentPage = event.detail.value;
    this.getSldList(event.detail.value, event.detail.perPage);
  }

  /**
   * Function to get SLD list depending upon allSLDCheck
   */
  getSldList(page: number, perPage: number): void {
    if (this.allSLDCheck) {
      if (this.searchTerm === "") {
        this.filteredSlds = Array.from(this.allSLD); // Reset to allSLD
      } else {
        this.filteredSlds = Array.from(this.allSLD).filter((sld: CubicleSld) =>
          sld.nameKey.toLowerCase().includes(this.searchTerm.toLowerCase())
        );
      }
    } else {
      if (this.searchTerm === "") {
        this.filteredSlds = this.sldList;
      } else {
        this.filteredSlds = this.sldList.filter(sld => sld.nameKey.toLowerCase().includes(this.searchTerm.toLowerCase()));
      }
    }
    this.setPaginatedResult(this.filteredSlds, page, perPage);
  }

  setPaginatedResult(filteredSlds: CubicleSld[], page: number, perPage:number): void{
    this.pageTotal = Math.ceil(filteredSlds.length / perPage);
    const fromIndex = (page - 1) * perPage;
    const toIndex = Math.min(fromIndex + perPage, filteredSlds.length);
    this.paginatedFilteredSlds = this.filteredSlds.slice(fromIndex, toIndex);
  }
  /**
   * Reset the component to initial state
   */
  private initParameters() {
    this.isSettingNumberOfFunction = true;
    this.currentPage = 1;
    this.numberOfFunction = 1;
    this.currentFunction = 1;
    this.hasSelectedSld = false;
    this.listOfSelectedSlds = [];
    this.initializeAllSLD();
    this.allSLDCheck = false;
    this.searchTerm="";
  }

  //  Initialize allSLD list from sldJson
  private initializeAllSLD() {
    if (!this.allSLD || this.allSLD.size === 0) {
      this.allSLD = new Set<CubicleSld>();
      for (const item of sldJson.allSldsNames) {
        this.allSLD.add(new CubicleSld(item, OfferDataManagementHelper.getSvgFileNameWithoutExtension(item)));
      }
    }
  }

  onSearchInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.searchTerm = input.value.trim();
    this.currentPage = 1;
    this.getSldList(1, this.perPage);
  }

}
